import { useState, useRef, useCallback, useImperativeHandle, useEffect } from 'react';
import { o as observerDomResize, d as debounce } from './index-65ee9985.js';
import { s as slicedToArray, _ as _extends } from './_babelHelpers-a63acad8.js';
function useAutoResize(ref) {
  var _useState = useState({
      width: 0,
      height: 0
    }),
    _useState2 = slicedToArray(_useState, 2),
    state = _useState2[0],
    setState = _useState2[1];
  var domRef = useRef(null);
  var setWH = useCallback(function () {
    var _ref = domRef.current || {
        clientWidth: 0,
        clientHeight: 0
      },
      clientWidth = _ref.clientWidth,
      clientHeight = _ref.clientHeight;
    setState({
      width: clientWidth,
      height: clientHeight
    });
    if (!domRef.current) {
      console.warn('DataV: Failed to get dom node, component rendering may be abnormal!');
    } else if (!clientWidth || !clientHeight) {
      console.warn('DataV: Component width or height is 0px, rendering abnormality may occur!');
    }
  }, []);
  useImperativeHandle(ref, function () {
    return {
      setWH: setWH
    };
  }, []);
  useEffect(function () {
    var debounceSetWHFun = debounce(setWH, 100);
    debounceSetWHFun();
    var domObserver = observerDomResize(domRef.current, debounceSetWHFun);
    window.addEventListener('resize', debounceSetWHFun);
    return function () {
      window.removeEventListener('resize', debounceSetWHFun);
      if (!domObserver) {
        return;
      }
      domObserver.disconnect();
      domObserver.takeRecords();
    };
  }, []);
  return _extends({}, state, {
    domRef: domRef,
    setWH: setWH
  });
}
export { useAutoResize as u };